export default __webpack_public_path__ + "static/media/recorte_23.d4c0780b.JPG";